<template>
    <console-layout width="100%" max-width="1024">

        <console-title>
            <span v-if="$route.params._setting">경품 상세</span>
            <span v-else>경품 생성</span>
        </console-title>

        <console-body>
            <v-card :disabled="!$hasScope(['root', 'admin'])">
                <v-card-title class="subtitle-2">기본정보</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="config.ranking" label="경품 등 수" persistent-placeholder hide-details :readonly="$route.params._setting"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="config.name" label="경품 이름" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="config.stock" label="경품 재고" persistent-placeholder hide-details :readonly="$route.params._setting"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="config.stockCount" v-if="$route.params._setting" label="당첨 횟수" persistent-placeholder hide-details :readonly="$route.params._setting"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="config.percentage" label="경품 확률" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions />
            </v-card>
    
            <v-card class="mt-4" :disabled="!$hasScope(['root', 'admin'])">
                <v-card-title class="subtitle-2">경품 이미지</v-card-title>
                <v-card-text>
                    <product-image v-model="config.image" label="이미지" @remove="removeThumb"></product-image>
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4" :disabled="!$hasScope(['root', 'admin'])">
                <v-card-title class="subtitle-2">당첨 이미지</v-card-title>
                <v-card-text>
                    <product-image v-model="config.image2" label="이미지" @remove="removeThumb"></product-image>
                </v-card-text>
            </v-card>
        </console-body>


        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import ProductImage from "@/components/console/shop/products/product-image.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        VPasswordField,
        ProductImage
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            admin: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,
            },
            config: {
                name: null,
                image: null,
                image2: null,
                percentage: null,
                stock: null,
                ranking: null
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._setting){
                let { config } = await api.console.hunt.configs.get({ _id: this.$route.params._setting })
                this.config = config
            }
            if(this.config.image) this.config.image = await api.getResource(this.config.image)
            if(this.config.image2) this.config.image2 = await api.getResource(this.config.image2)
        },

        async save(){
            let { config } = this.config._id ? await api.console.hunt.configs.put({...this.config, image: null, image2: null}) : await api.console.hunt.configs.post({...this.config, image: null, image2: null})

            if(this.config.image) {
                let { image } = await api.console.hunt.configs.image.post(config._id, this.config.image);
                this.config.image = image;
            }

            if(this.config.image2) {
                let { image2 } = await api.console.hunt.configs.image.post2(config._id, this.config.image2);
                this.config.image2 = image2;
            }

            alert("저장되었습니다");
            this.$router.push(`/console/hunt/setting`);
        },

        async removeThumb(){
            try{
                if(confirm("상품 썸네일을 삭제하시겠습니까?")){
                    this.config.image = null;
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        createObjectURL(file){
            try{ return URL.createObjectURL(file); }
            catch(error){}
        },
    }
}
</script>